import products from './products'
import tasks from './tasks'
import user from './user'
import patients from './patients'
import medicines from './medicines'
import Location from './Location'
import Task from './Task'
import TaskLog from './TaskLog'
import Procedure from './Procedure'
import Instruction from './Instruction'
import RequestForRation from './RequestForRation'
import RationLog from './RationLog'
import TransportRequest from './TransportRequest'
import RationDistributor from './RationDistributor'
import TransportVehicle from './TransportVehicle'
import twilloToken from './twillo'
export default {
  patients,
  products,
  tasks,
  user,
  twilloToken,
  medicines,
  Instruction,
  Procedure,
  Task,
  TaskLog,
  Location,
  RequestForRation,
  RationLog,
  TransportRequest,
  RationDistributor,
  TransportVehicle
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/index.js